var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteFormAdaptive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#0DD1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.595 11.438a.616.616 0 01-.403-.162L3.369 8.373a.633.633 0 010-.887.633.633 0 01.887 0l2.339 2.42 4.92-5.162a.633.633 0 01.886 0 .633.633 0 010 .887L7.08 11.276c-.162.08-.323.162-.484.162z",
    fill: "#fff"
  })));
}
export default SvgCompleteFormAdaptive;